var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent, Children, cloneElement } from 'react';
import { timelineProps } from './defaults';
import { TimelineItem } from './TimelineItem';
import { DivTag } from '../../Utils/AtomicTag';
var Timeline = /** @class */ (function (_super) {
    __extends(Timeline, _super);
    function Timeline(props) {
        var _this = _super.call(this, props) || this;
        _this.getNewPanel = function (child, index) {
            var align = _this.props.align;
            var props = __assign({ align: align }, child.props);
            return cloneElement(child, props);
        };
        _this.renderPanel = function () {
            var children = _this.props.children;
            if (!children) {
                return null;
            }
            return Children.map(children, function (child, index) {
                return _this.getNewPanel(child, index);
            });
        };
        return _this;
    }
    Timeline.prototype.render = function () {
        var _a = this.props, className = _a.className, align = _a.align, style = _a.style;
        var renderPanel = this.renderPanel();
        return (React.createElement(DivTag, { name: Timeline.NAME, className: className, autoPrefixedClassName: "timeline-" + align, style: style },
            React.createElement("ul", null, renderPanel)));
    };
    Timeline.Item = TimelineItem;
    Timeline.defaultProps = timelineProps;
    Timeline.NAME = 'timeline';
    Timeline.displayName = 'Timeline';
    return Timeline;
}(PureComponent));
export { Timeline };
